import { EventEmitter } from 'events';
import dispatcher from '../dispatcher';
import constants from '../constants';
import OfficeTypeStore from './OfficeTypeStore';
import GeometryStore from './GeometryStore';

class LocationStore extends EventEmitter {
    constructor() {
        super()

        // Set default state
        this.searchResults = [];
        this.filteredSearchResults = false;
    }

    handleActions(action) {
        switch(action.type) {
            case constants.LOCATIONS_GET_RESPONSE: {
                this.setSearchResults(action.searchResults);
                break;
            }
            case constants.LOCATIONS_SELECTED_SET: {
                this.setSelectedSearchResult(action.searchResultId);
                break;
            }
            case constants.OFFICE_TYPE_TOGGLE: {
                // Wait for OfficeTypeStore
                dispatcher.waitFor([OfficeTypeStore.dispatchToken]);
                // Filter results by OfficeTypes
                this.filterSearchResultsByOfficeTypes(OfficeTypeStore.getSelectedOfficesTypes());
                break;
            }
            case constants.GEOMETRY_SET: {
                // Wait for GeometryStore
                dispatcher.waitFor([GeometryStore.dispatchToken]);
                // Filter results by Geometry
                // TODO
                break;
            }
        }
    }

    populateLocations(locations) {
        this.searchResults = locations;
    }

    setSearchResults(searchResults) {
        this.filteredSearchResults = false;
        this.searchResults = searchResults;

        this.searchResults.map((sr) => {
            sr.IsSelected = false;
            return sr;
        })

        this.emit('change');
    }

    getSearchResults() {
        return this.filteredSearchResults !== false ? this.filteredSearchResults : this.searchResults;
    }
    
    setSelectedSearchResult(searchResultId) {
        this.searchResults.map((sr) => {
            sr.IsSelected = (sr.Id == searchResultId);
            return sr;
        })
        
        this.emit('change');
    }

    getSelectedSearchResult() {
        var selectedSearchResult = this.searchResults.find(sr => sr.IsSelected);
        if(selectedSearchResult !== undefined)
            return selectedSearchResult;
        
        return null;
    }

    filterSearchResultsByOfficeTypes(officeTypes){
        this.filteredSearchResults = this.searchResults.filter((sr) => {
            if (officeTypes.filter((ot) => ot.Id == sr.OfficeType.Id).length > 0) {
                return sr;
            }
        });

        this.emit('change');
    }
}

const locationStore = new LocationStore;
locationStore.dispatchToken = dispatcher.register(locationStore.handleActions.bind(locationStore));

export default locationStore;